<template>
  <div class="segment">
      <h1 class="title has-text-centered">Shots - Heatmap</h1>

          <div class="small-box">
            <h2 class="subtitle">Controls</h2>
            <div class="columns">
              <div class="column is-2">
                <div class="field is-horizontal">
                  <div class="control">
                    <label class="label">Situation</label>
                      <div class="control">
                        <div class="select">
                          <select v-model="SituationSelected"  @change="fetchShotmap">
                            <option v-for="option in SituationOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
                          </select>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
<!--
              <div class="column">
                <label class="label">Home Player(s)</label>
                <multiselect class="" v-model="HomeMultiSelect"  :searchable="true" :options="HomeTeamOptions"  @close="fetchShotmap" :max-height="250" :option-height="30" :multiple="true" :close-on-select="true" label="text" track-by="text" :preselect-first="true" :hide-selected="false" placeholder="All">
                  <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="HomeMultiSelect.length &amp;&amp; !isOpen">{{ HomeMultiSelect.length }} selected</span></template>
                </multiselect>
              </div>
              <div class="column">
                <label class="label">Away Player(s)</label>
                <multiselect class="" v-model="AwayMultiSelect"  :searchable="true" :options="AwayTeamOptions"  @close="fetchShotmap" :max-height="250" :option-height="30" :multiple="true" :close-on-select="true" label="text" track-by="text" :preselect-first="true" :hide-selected="false" placeholder="All">
                  <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="AwayMultiSelect.length &amp;&amp; !isOpen">{{ AwayMultiSelect.length }} selected</span></template>
                </multiselect>
              </div>
              -->
              <div class="column is-2">
                <div class="field is-horizontal">
                  <div class="control">
                    <label class="label">Shot type</label>
                      <div class="control">
                        <div class="select">
                          <select v-model="ShotTypeSelected" @change="fetchShotmap">
                            <option v-for="option in ShotTypeOptions" v-bind:value="option.value" v-bind:key="option.text">{{option.text}}</option>
                          </select>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="columns">
              <div class="column is-2">
                <label></label>
                <div class="control">
                  <button class="button is-primary is-medium" @click="UseHeatmap = !UseHeatmap; renderHeatmap()">Heatmap</button>
                </div>
              </div>
              <div class="column is-2" v-if="UseHeatmap">
                <label class="label">Blur</label>
                <div class="control">
                  <input class="input is-small" type="number" step="any" placeholder="0.5" v-model="BlurSelected" @change="renderHeatmap">
                </div>
              </div>
              <div class="column is-2" v-if="UseHeatmap">
                <label class="label" >Radius</label>
                <div class="control">
                  <input class="input is-small" type="number" step="any" placeholder="0.5" v-model="RadiusSelected" @change="renderHeatmap">
                </div>
              </div>
              <div class="column is-2">
                <label></label>
                <div class="control">
                  <button class="button is-primary is-medium" @click="UseShotZones = !UseShotZones; renderHeatmap()">Shot Zones</button>
                </div>
              </div>
              <div class="column is-2" v-if="UseShotZones">
                <div class="control">
                  <button class="button is-primary is-medium" @click="UseShotZonesText = !UseShotZonesText; renderHeatmap()">Toggle Zone Count</button>
                </div>
              </div>
            </div>
          </div>
        <div class="columns is-vcentered">
          <div class="column is-half is-offset-1">
            <h2 class="subtitle">{{home_name}}</h2>
            <canvas id='home_shotmap' ref="home_shot_canvas" class="is-canvas-responsive shotmap" width="412" height="520"></canvas>
          </div>
          <div class="column is-half">
            <h1 class="subtitle">{{away_name}}</h1>
            <canvas id='away_shotmap' ref="away_shot_canvas" class="is-canvas-responsive shotmap" width="412" height="520"></canvas>
          </div>
        </div>
  </div>
</template>
<script>
  import simpleheat from '../../store/modules/simpleheat/simpleheat'
  import simpleshot from '../../store/modules/simpleheat/simpleshot'
  import Multiselect from 'vue-multiselect'
  export default {
    props: ['defaultShow', 'home_name', 'away_name', 'opponent', 'venue', 'competition', 'year', 'home_id', 'away_id'],
    components: {
      'simpleheat': simpleheat,
      'simpleshot': simpleshot,
      Multiselect
    },
    data: function () {
      return {
        show: true,
        gameId: 0,
        SituationOptions: [],
        SituationSelected: 0,
        HomePlayers: [],
        AwayPlayers: [],
        HomeTeamOptions: [],
        HomeSelection: 0,
        AwayTeamOptions: [],
        AwaySelection: 0,
        ShotTypeSelected: 0,
        ShotTypeOptions: [],
        RadiusSelected: 15,
        BlurSelected: 40,
        UseHeatmap: false,
        UseShotZones: false,
        UseShotZonesText: true,
        HomeMultiSelect: [],
        AwayMultiSelect: []
      }
    },
    computed: {
      sortHomePlayers: function () {
        return this.HomePlayers.slice().sort(function (a, b) {
          return (a.number - b.number)
        })
      },
      sortAwayPlayers: function () {
        return this.AwayPlayers.slice().sort(function (a, b) {
          return (a.number - b.number)
        })
      }
    },
    methods: {
      renderShotZones (canvas, shotData) {
        /*eslint-disable */
        var ctx = canvas.getContext('2d')
        let testColor = 'rgba(250, 1, 1, 0.02)'

        let redZoneColour = 'rgba(250, 1, 1, 0.22)'
        let colour = 'rgba(254, 254, 254, 0.22)'
        let centerPos = [105, 76, 205, 170]

        let outsideZonePos = [0, 360, 590, 140]

        let behindNetPos = [0, 0, 590, 75]

        let leftOutsidePos = [0, 76, 105, 170]

        let rightOutsidePos = [310, 76, 155, 170]

        let leftPointInit = [0, 245]
        let leftPointLines = [{x: 0, y: 245}, {x: 105, y: 245}, {x: 130, y: 360}, {x: 0, y: 360}, {x: 0, y: 0}]

        let centerPointInit = [105, 245]
        let centerPointLines = [{x: 105, y: 245}, {x: 310, y: 245}, {x: 280, y: 360}, {x: 130, y: 360}, {x: 105, y: 245}]

        let rightPointInit = [420, 245]
        let rightPointLines = [{x: 420, y: 245}, {x: 310, y: 245}, {x: 280, y: 360}, {x: 420, y: 360}, {x: 420, y: 370}]

        
        this.drawRect(ctx, colour, outsideZonePos, '12px', 1)
        this.drawRect(ctx, colour, behindNetPos)
        this.drawRect(ctx, colour, leftOutsidePos)
        this.drawRect(ctx, colour, rightOutsidePos)
        this.drawRect(ctx, redZoneColour, centerPos)
        this.drawCustom(ctx, colour, leftPointInit, leftPointLines)
        this.drawCustom(ctx, colour, centerPointInit, centerPointLines)
        this.drawCustom(ctx, colour, rightPointInit, rightPointLines)

        let leftOTCount = 0
        let rightOTCount = 0
        let centerCount = 0
        let behindCount = 0
        let leftPointCount = 0
        let rightPointCount = 0
        let centerPointCount = 0
        let outsideZoneCount = 0
        let redZoneCount = 0
        let behindNetCount = 0
        let totalShots = 0
        console.log(JSON.stringify(shotData))
        for (var shot of shotData) {
          // let s = JSON.parse(shot.shot_location)
          totalShots++
          // Left Outside Count         let leftOutsidePos = [0, 76, 105, 170]
          if (shot[0] >= 0.0 && shot[0] <= 105.0 && shot[1] > 76.0 && shot[1] < 246) {
            // console.log('Shot found: ' + shot[0]  + ' '  + shot[1])
            leftOTCount++
          }
          // Right Outside Count         [310, 76, 155, 170]
          if (shot[0] >= 312 && shot[0] <= 476 && shot[1] > 76.0 && shot[1] < 246) {
             // console.log('Shot found: ' + shot[0]  + ' '  + shot[1])
            rightOTCount++
          }
          // Cneter Count         [105, 76, 205, 170]
          //  this.drawRect(ctx, testColor, [105, 76, 205, 170])
          if (shot[0] >= 105 && shot[0] <= 310 && shot[1] > 76.0 && shot[1] < 246) {
            redZoneCount++
          }
          //{x: 0, y: 245}, {x: 105, y: 245}, {x: 160, y: 360}, {x: 0, y: 360}, {x: 0, y: 370}
          // let leftPointLines = [{x: 0, y: 245}, {x: 105, y: 245}, {x: 130, y: 360}, {x: 0, y: 360}, {x: 0, y: 0}]
          // this.drawCustom(ctx, testColor, leftPointInit, leftPointLines)
          if (shot[0] >= 0 && shot[0] <= 115.0 && shot[1] > 245 && shot[1] < 360) {
            leftPointCount++
          }
          // Right Point  [{x: 420, y: 245}, {x: 310, y: 245}, {x: 280, y: 360}, {x: 420, y: 360}, {x: 420, y: 370}]
          if (shot[0] >= 280 && shot[0] <= 420 && shot[1] > 245 && shot[1] < 360) {
            rightPointCount++
          }
          // Center Point  [{x: 105, y: 245}, {x: 310, y: 245}, {x: 280, y: 360}, {x: 130, y: 360}, {x: 105, y: 245}]
          if (shot[0] >= 116.0 && shot[0] <= 270.0 && shot[1] > 245 && shot[1] < 360) {
            centerPointCount++
          }
          // Outside Zone  [0, 360, 590, 140]
          if (shot[0] >= 0 && shot[0] <= 420 && shot[1] > 360.1 && shot[1] < 590.0) {
            outsideZoneCount++
          }
          // Behind Net  [0, 0, 590, 75]
          if (shot[0] >= 0 && shot[0] <= 420 && shot[1] > 0 && shot[1] < 75.0) {
            behindNetCount++
          }
        }
        if (this.UseShotZonesText) {
          this.drawText(ctx, leftOTCount + ' ' + (leftOTCount / totalShots * 100).toPrecision(2) + '%', [40, 100], '18px')
          this.drawText(ctx, rightOTCount  + ' ' + (rightOTCount / totalShots * 100).toPrecision(2) + '%', [340, 100], '18px')
          this.drawText(ctx, redZoneCount + ' ' + (redZoneCount / totalShots * 100).toPrecision(2) + '%', [180, 95], '18px', 'black')
          this.drawText(ctx, leftPointCount  + ' ' + (leftPointCount / totalShots * 100).toPrecision(2) + '%', [40, 270], '18px')
          this.drawText(ctx, rightPointCount + ' ' + (rightPointCount / totalShots * 100).toPrecision(2) + '%', [340, 270], '18px')
          this.drawText(ctx, centerPointCount + ' ' + (centerPointCount / totalShots * 100).toPrecision(2) + '%', [190, 270], '18px')
          this.drawText(ctx, outsideZoneCount + ' ' + (outsideZoneCount / totalShots * 100).toPrecision(2) + '%', [190, 390], '18px')
          this.drawText(ctx, behindNetCount + ' ' + (behindNetCount / totalShots * 100).toPrecision(2) + '%', [190, 30], '18px')
        }
      },
      drawRect (ctx, color, position, text, textPos, fontSize = '26px', lineWidth = 3) {
        ctx.beginPath()
        ctx.fillStyle = color
        ctx.strokeStyle = '#FFFFFF'
        ctx.shadowOffsetX = ctx.shadowOffsetY = .0;
        ctx.shadowBlur = .2;
        ctx.shadowColor = 'rgb(1, 1, 1)';
        ctx.lineWidth = lineWidth
        ctx.fillRect(position[0], position[1], position[2], position[3])
        ctx.strokeRect(position[0], position[1], position[2], position[3])
        ctx.closePath()
      },
      drawText (ctx, text, textPosition, textSize = '26px', colour='rgba(0,0,0,1)') {
        ctx.beginPath()
        ctx.font = textSize + ' sans-serif'
        ctx.fillStyle = colour
        ctx.fillText(text, textPosition[0], textPosition[1])
        ctx.closePath()
      },
      drawCustom (ctx, color, initPos, movePoints) {
        ctx.beginPath()
        ctx.fillStyle = color
        // ctx.strokeStyle = 'white'
        ctx.moveTo(initPos[0], initPos[1])
        // Loop over move points
        for (var prop of movePoints) {
          ctx.lineTo(prop.x, prop.y)
        }
        ctx.fill()
        ctx.stroke()
        ctx.closePath()
      },
      renderHeatmap () {
        var homeShotsCanvas = this.$refs.home_shot_canvas
        var awayShotsCanvas = this.$refs.away_shot_canvas
        let homeShots = []
        let awayShots = []
        for (var shots of this.HomeShotmapData) {
          let shot = JSON.parse(shots.shot_location)
          shot[0] = (homeShotsCanvas.width / 600.0) * parseInt(shot[0], 10)
          shot[1] = (homeShotsCanvas.height / 530.0) * parseInt(shot[1], 10)
          if (this.UseHeatmap === false) {
            if (shots.shot_type === 'OnNet') {
              shot[4] = 'rgb(180, 8, 8)'
              shot[3] = 5
            } else if (shots.shot_type === 'MissedNet') {
              shot[4] = 'rgba(95, 93, 93)'
              shot[3] = 3
            } else if (shots.shot_type === 'Blocked') {
              shot[4] = 'rgba(20, 23, 81)'
              shot[3] = 3
            } else if (shots.shot_type === 'Goal') {
              shot[4] = 'rgb(31, 239, 0)'
              shot[3] = 6
            } else {
              shot[4] = 'White'
            }
          }
          homeShots.push(shot)
        }
        for (shots of this.AwayShotmapData) {
          let shot = JSON.parse(shots.shot_location)
          shot[0] = (awayShotsCanvas.width / 600.0) * shot[0]
          shot[1] = (awayShotsCanvas.height / 530.0) * shot[1]
          if (this.UseHeatmap === false) {
            if (shots.shot_type === 'OnNet') {
              shot[4] = 'rgb(180, 8, 8)'
              shot[3] = 5
            } else if (shots.shot_type === 'MissedNet') {
              shot[4] = 'rgba(95, 93, 93)'
              shot[3] = 3
            } else if (shots.shot_type === 'Blocked') {
              shot[4] = 'rgba(20, 23, 81)'
              shot[3] = 3
            } else if (shots.shot_type === 'Goal') {
              shot[4] = 'rgb(31, 239, 0)'
              shot[3] = 6
            } else {
              shot[4] = 'White'
            }
          }
          awayShots.push(shot)
        }
        if (this.UseHeatmap === true) {
          var homeHeatmap = simpleheat(homeShotsCanvas).data(homeShots)
          homeHeatmap.radius(this.RadiusSelected, this.BlurSelected)
          homeHeatmap.draw()

          var awayHeatmap = simpleheat(awayShotsCanvas).data(awayShots)
          awayHeatmap.radius(this.RadiusSelected, this.BlurSelected)
          awayHeatmap.draw()
        } else {
          homeHeatmap = simpleshot(homeShotsCanvas).data(homeShots)
          homeHeatmap.render()

          awayHeatmap = simpleshot(awayShotsCanvas).data(awayShots)
          awayHeatmap.render()
        }
        if (this.UseShotZones) {
          this.renderShotZones(homeShotsCanvas, homeShots)
          this.renderShotZones(awayShotsCanvas, awayShots)
        }
      },
      filterPlayers (selectResult) {
        let players = []
        for (var p of selectResult) {
          if (p.id === 0) {
            return 0
          } else {
            players.push(p.id)
          }
        }
        return JSON.stringify(players)
      },
      fetchShotmap () {
        let postData = {
          'id': this.gameId,
          'period': this.PeriodSelected,
          'situation': this.SituationSelected,
          'home_player': this.filterPlayers(this.HomeMultiSelect),
          'away_player': this.filterPlayers(this.AwayMultiSelect),
          'shot_type': this.ShotTypeSelected,
          'opponent': this.opponent,
          'venue': this.venue,
          'competition': this.competition,
          'year': this.year,
          'home_id': this.home_id,
          'away_id': this.away_id
        }
        console.log('Filter: ' + JSON.stringify(postData))
        this.$http
          .post('https://devilsapi.roblutken.com/api/app/season-stats/team-shotmap/', postData, {
            headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'application/json' }
          })
          .then(
            response => {
              console.log(response.data)
              this.HomeShotmapData = response.data.home_shots
              this.AwayShotmapData = response.data.away_shots
              this.renderHeatmap()
            },
            response => { }
          )
      },
      fetchPlayers () {
        // this.$http.get('https://devilsapi.roblutken.com/api/app/get/players/shots/' + this.gameId, {
        //   headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
        // }).then(
        //   response => {
        //     // console.log(JSON.stringify(response.data))
        //     this.HomePlayers = response.data.home_players
        //     this.AwayPlayers = response.data.away_players
        //     // console.log(JSON.stringify(this.HomePlayers))
        //     this.HomeTeamOptions.push({ text: 'All', id: 0 })
        //     this.AwayTeamOptions.push({ text: 'All', id: 0 })

        //     this.HomeTeamOptions.push({ text: 'Forwards', id: 0 })
        //     for (var i of this.sortHomePlayers) {
        //       if (i.position === 'LW' || i.position === 'C' || i.position === 'RW') {
        //         if (i.number > 0) {
        //           this.HomeTeamOptions.push({ text: i.number + ' ' + i.surname, id: i.id })
        //         }
        //       }
        //     }
        //     this.HomeTeamOptions.push({ text: 'Defense', id: -7 })
        //     for (var d of this.sortHomePlayers) {
        //       if (d.position === 'LD' || d.position === 'RD') {
        //         this.HomeTeamOptions.push({ text: d.number + ' ' + d.surname, id: d.id })
        //       }
        //     }
        //     this.AwayTeamOptions.push({ text: 'Forwards', id: -2 })
        //     for (var af of this.sortAwayPlayers) {
        //       if (af.position === 'LW' || af.position === 'C' || af.position === 'RW') {
        //         if (af.number > 0) {
        //           this.AwayTeamOptions.push({ text: af.number + ' ' + af.surname, id: af.id })
        //         }
        //       }
        //     }
        //     this.AwayTeamOptions.push({ text: 'Defense', value: -3 })
        //     for (var ad of this.sortAwayPlayers) {
        //       if (ad.position === 'LD' || ad.position === 'RD') {
        //         this.AwayTeamOptions.push({ text: ad.number + ' ' + ad.surname, id: ad.id })
        //       }
        //     }
        //   })
      },
      fetchFilterOptions () {
        this.$http.get('https://devilsapi.roblutken.com/api/app/season-stats/filters/', {
          headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' }
        }).then(
          response => {
            this.SituationOptions.push({ text: 'All', value: 0 })
            this.SituationOptions.push({ text: 'Even Handed', value: 1 })
            this.SituationOptions.push({ text: 'Power Play', value: 2 })
            this.SituationOptions.push({ text: 'Short Handed', value: 3 })
            this.SituationOptions.push({ text: 'Empty Net', value: 4 })

            this.ShotTypeOptions.push({ text: 'All', value: 0 })
            this.ShotTypeOptions.push({ text: 'On Net', value: 'OnNet' })
            this.ShotTypeOptions.push({ text: 'Off Target', value: 'MissedNet' })
            this.ShotTypeOptions.push({ text: 'Blocked', value: 'Blocked' })
            this.ShotTypeOptions.push({ text: 'Goal', value: 'Goal' })
          }
        )
      }
    },
    mounted () {
      if (this.defaultShow) {
        this.show = true
      }
      console.log(this.opponent)
      this.fetchShotmap()
      this.fetchPlayers()
      this.fetchFilterOptions()
    },
    watch: {
        opponent: function (val) {
            this.fetchShotmap()
        }
    }
  }
</script>
<style lang='scss' scoped>
  .table__wrapper {
    overflow-x: auto;
  }
  .shotmap {
    background: url('~assets/HalfRink.svg');
    background-repeat: no-repeat;
  }
  
.segment h1 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 3em;
}
.segment h2 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 2em;
}
.segment p{
  font-size:1.2em;
  text-transform: uppercase;
}
.segment label{
  font-size:1.2em;
  text-transform: capitalize;
  color:rgb(53, 53, 53)
}
.stat-title{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.3rem;
  margin: 1rem 0rem;
}
.stat-category{
  font-family: 'Heebo', sans-serif;
  font-weight: 100;
  text-transform: capitalize;
  color:rgb(29, 29, 29);
  font-size: 1.5rem;
  margin: 1rem 0rem;
}
.stat-number{
  font-family: 'Heebo', sans-serif;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 1.3rem;
  margin: 1rem 0rem;
  color:black;
}
  .small-box {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 98%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 8px 3px rgba(112, 111, 112, 0.068);
  -moz-box-shadow:  -2px -1px 8px 3px rgba(112, 111, 112, 0.068);
  box-shadow:  -2px -1px 8px 3px rgba(112, 111, 112, 0.068);
}
</style>



// WEBPACK FOOTER //
// shots-heatmap-team.vue?7318542c